import { FieldsOrder } from "../Subjects/types";

export enum AccountRole {
    ADMIN = "ADMIN",
    USER = "USER",
    ADJUDICATOR = "ADJUDICATOR"
}

export enum AccountsFieldOrderBy {
    USERNAME = "USERNAME",
    ROLES = "ROLES"
}

export interface IAccountFilter {
    accountFieldToOrderBy?: "USERNAME" | "ROLES",
    fieldsOrder?: FieldsOrder,

    accountRoles?: AccountRole[],
    username?: string,
    uuid?: string
}